<template lang="pug">
.form-transfer-delegation
  h2 签署转让委托

  el-form.ui.form(:model='form', ref='form')

    .equal.width.fields
      el-form-item.ui.field.disabled
        label 押金
        el-input(v-model='deposit_money', type='text')
      el-form-item.ui.field.required
        label 转让手续费
        el-input-number(v-model='form.delegation_fee', :min='0')
      el-form-item.ui.field.disabled
        label 可用金额
        el-input(:value='deposit_money - form.delegation_fee', type='text')

    .equal.width.fields
      el-form-item.ui.field.disabled
        label 租金 / 月
        el-input(v-model='price_month', type='text')
      el-form-item.ui.field.disabled
        label 管理费 / 月
        el-input(v-model='management_fee_month', type='text')
      el-form-item.ui.field.required
        label 日租金 ({{average_price_day}})
        el-input-number(v-model='form.price_day', :min='0')
      el-form-item.ui.field.disabled
        label 委托天数(+{{extra_delegation_days}})
        el-input(:value='delegation_days', type='text')

    .equal.width.fields
      el-form-item.ui.field.required
        label 委托开始日期
        datepicker(v-model='form.date_start', type='date', placeholder='开始日期')

      el-form-item.ui.field.disabled
        label 委托结束日期
        datepicker(:value='date_end', type='date', placeholder='结束日期')


    h3 委托人信息
    .equal.width.fields
      el-form-item.ui.field.required(prop='customer_name')
        label 姓名
        el-input(v-model='form.customer_name', type='text')
      el-form-item.ui.field.required(prop='customer_phone')
        label 手机
        el-input(v-model='form.customer_phone', type='text')

    h3 备注
    el-form-item.ui.field(prop='note')
      textarea(v-model='form.note', rows='2')

    .ui.field.actions
      // .ui.button.blue(@click='print_draft()') Print

      .ui.button.themed.icon.labeled(@click='finish')
        i.icon.checkmark
        | 确认签署
      .ui.button(@click='cancel') 取消
</template>

<script>
import { MakeForm } from '../../utils'
import { PaymentMethodSelect, Datepicker } from '../basic'

export default {
  name: 'form-transfer-delegation',
  components: {
    PaymentMethodSelect,
    Datepicker,
  },
  props: ['no', 'contract_id'],
  computed: {
    room() {
      return this.$store.getters.room(this.no)
    },
    contract() {
      return this.$store.getters.contract(this.contract_id)
    },
    customers() {
      return this.$store.getters.customers_filter(this.contract._customers)
    },
    price_month() {
      return this.contract.price_month
    },
    management_fee_month() {
      return this.contract.management_fee_month
    },
    deposit_money() {
      return this.contract.deposit_money
    },
    average_price_day() {
      return Math.round((this.price_month + this.management_fee_month) / 30)
    },
    delegation_fee() {
      return Math.round(this.price_month / 2)
    },
    extra_delegation_days() {
      return Math.floor((this.deposit_money - this.form.delegation_fee) / this.form.price_day)
    },
    delegation_days() {
      let end = this.$moment(this.contract.date_expire).add(this.extra_delegation_days, 'days')
      if (end.isAfter(this.$moment(this.contract.date_end)))
        end = this.$moment(this.contract.date_end)
      return -this.$moment(this.form.date_start).diff(end, 'days')
    },
    date_end() {
      return this.$moment(this.form.date_start).add(this.delegation_days, 'days')
    },
    submiting_form() {
      return Object.assign(
        {}, this.form,
        {
          delegation_days: this.delegation_days,
          date_end: this.date_end,
        })
    },
  },
  data() {
    return {
      form: {
        customer_name: '',
        customer_phone: '',
        room_state: 'avaliable',
        price_day: 0,
        deposit_money: 0,
        delegation_fee: 0,
        note: '',
        date_delegation: this.$moment(),
        date_start: this.$moment(),
      },
    }
  },
  watch: {

  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.form.date_start = this.$moment().startOf('day')
      this.form.customer_name = (this.customers[0] || {}).name
      this.form.customer_phone = (this.customers[0] || {}).phone1
      this.recalc_price()
    },
    recalc_price() {
      this.form.price_day = this.average_price_day
      this.form.delegation_fee = this.delegation_fee
    },
    cancel() {
      this.$router.back()
    },
    submit_form: MakeForm({
      type: 'post',
      url() { return `contracts/${this.contract_id}/transfer_delegation` },
      confirm: '确定签署转让委托？',
      payload() {
        return { transfer_delegation: this.submiting_form }
      },
      $afterSuccess() {
        this.print_draft()
        this.$store.dispatch('load_summary', this)
        this.$router.back()
      },
    }),
    finish() {
      this.$refs.form.validate((valid) => {
        if (valid)
          this.submit_form()
      })
    },
    print_draft() {
      this.$templater.request('transfer_delegation', {
        room: this.room,
        contract: this.contract,
        transfer_delegation: this.submiting_form,
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// FormTransferDelegation.vue?501d815c